import type { Paths, UnionToTuple } from "type-fest";
import { z } from "zod";

import { zOutSchema } from "./common";

import type { ServiceServicePorts } from "~/entities/service";
import { Request, Response } from "~/shared/api";

const zRes = Response.Schema.zSuccessful(200, Request.Pagination.Page.zSchema(zOutSchema));
type Res = z.infer<typeof zRes>;

const zFieldsToSortBy = z.enum(
  Object.values(zRes.shape.body.shape.data.shape.items.element.keyof().Enum) as UnionToTuple<
    Paths<Res["body"]["data"]["items"][number]>
  >,
);
const FieldsToSortBy = zFieldsToSortBy.Enum;
type FieldsToSortBy = z.infer<typeof zFieldsToSortBy>;

const MAP_OF_FIELDS_TO_SORT_BY: Record<
  ServiceServicePorts.ProviderIos.GetPaginated.FieldsToSortBy,
  FieldsToSortBy
> = {
  id: "id",
  name: "name",
  description: "description",
  price: "price",
  isActive: "isActive",
  "category.name": "category.name",
};

export { FieldsToSortBy, MAP_OF_FIELDS_TO_SORT_BY, zFieldsToSortBy, zRes };
export type { Res };
